
const inputTextLimit = 250;

const capacityTextLimit = 10;

const radiusLimit = 15;

const inputDescLimit = 10000;

const limitFive = 5;

export { inputTextLimit, inputDescLimit, capacityTextLimit, limitFive, radiusLimit }
